import { useDispatch } from 'react-redux';
import { Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { hideModalAction } from 'Store/modules/app/actions';
import useTranslation from 'Hooks/useTranslation';
import { CloseIcon } from 'Components/icons';
import { removeOverflow } from 'Styles/utils/utils';
import * as Styled from './styles';

const InstantRefundModal = ({ data }: { data: { isRefundable: boolean } }): JSX.Element => {
  const { t } = useTranslation(locizeNS.MODALS);
  const dispatch = useDispatch();

  const closeModal = (): void => {
    removeOverflow();
    dispatch(hideModalAction());
  };
  return (
    <Styled.ModalContainer>
      <Styled.ModalContent gap="dimension_24">
        <Styled.CloseButton onClick={closeModal}>
          <CloseIcon />
        </Styled.CloseButton>
        <Text type="headline" size="XS_L_S" color="dark" align="center">
          {t('InstantRefund.modal.title')}
        </Text>
        <Text type="paragraphs" size="S_L_M" color="grey" align="center">
          {t('InstantRefund.modal.description', {
            context: !data.isRefundable && 'notRefund',
          })}
        </Text>
      </Styled.ModalContent>
    </Styled.ModalContainer>
  );
};

export default InstantRefundModal;
